import { RuntimeFilterOp } from '@thoughtspot/visual-embed-sdk/react';
import { MultiSelectWithQueriesUrl } from 'shared/ui/MultiSelect';
import { FILTER_STYLES } from 'shared/constants';
import { useGetServicesForFilters } from 'entities/service';
import { ContractorReportsFilter } from 'entities/reports';
import { useUrlResolver } from 'shared/lib/url';
import { useEffect } from 'react';

import { getLastNMonths, useGetQueryParams, useGetServicesOptionsAliasId } from '../utils';
import { LiveboardEmbedConstructor } from '../LiveboardEmbedConstructor';

import { getDateOptions } from './utils';

const LIVEBOARD_ID = 'ba05fa92-e10f-4f4a-a72c-2ab1f4bc2e53';

const selectedServicesQueryKey = ContractorReportsFilter.serviceIdArray;
const dateFromQueryKey = ContractorReportsFilter.from;

export function VerticalBenchmark() {
  const servicesOptions = useGetServicesOptionsAliasId();
  const servicesFiltersQuery = useGetServicesForFilters();

  const selectedServices = useGetQueryParams(selectedServicesQueryKey);

  const dateFrom = useGetQueryParams(dateFromQueryKey);
  const dateOptions = getDateOptions();

  const { addParam } = useUrlResolver();

  useEffect(() => {
    if (!dateFrom.length) {
      addParam(dateFromQueryKey, getLastNMonths(12));
    }
  }, []);

  const getRuntimeFilters = () => {
    const runtimeFilters = [];

    if (selectedServices.length && selectedServices.length < servicesOptions.length) {
      runtimeFilters.push({
        columnName: 'Service Alias',
        operator: RuntimeFilterOp.IN,
        values: selectedServices,
      });
    }

    if (dateFrom.length) {
      runtimeFilters.push({
        columnName: 'Date',
        operator: RuntimeFilterOp.GE,
        values: [dateFrom[0]],
      });
    }

    return runtimeFilters;
  };

  const runtimeFilters = getRuntimeFilters();
  const shouldLoadLiveboard = selectedServices.length > 0;

  return (
    <LiveboardEmbedConstructor
      type="infobox-disposition"
      filters={
        <>
          <MultiSelectWithQueriesUrl.Select
            rootClassName={`${FILTER_STYLES.select} min-w-[345px]`}
            title="Service"
            options={servicesOptions}
            disabled={servicesFiltersQuery.isLoading}
            loading={servicesFiltersQuery.isLoading}
            filterName={selectedServicesQueryKey}
            isWhite
            isHighlighted
          />
          <MultiSelectWithQueriesUrl.Select
            rootClassName={`${FILTER_STYLES.select} min-w-[345px]`}
            title="Datepicker"
            filterName={dateFromQueryKey}
            options={dateOptions}
            isWhite
            withCancel={false}
            leftIcon="calendar_month"
          />
        </>
      }
      title="Vertical benchmark"
      liveBoardId={LIVEBOARD_ID}
      runtimeFilters={runtimeFilters}
      shouldLoadLiveboard={shouldLoadLiveboard}
      notAvailableBackgroundSrc="/assets/reports/contractor/vertical-benchmark-background.jpg"
      infoboxTitleText="Select a service to view your report."
      infoboxText="All data related to the selected service will be shown."
    />
  );
}
